<script setup lang="ts">
import { computed, type HTMLAttributes } from "vue";

import { cn } from "../../lib/utils";
import type { ButtonColor, ButtonSize, ButtonVariant } from ".";

interface Props {
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
  class?: HTMLAttributes["class"];
  loading?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
}

const props = withDefaults(defineProps<Props>(), {
  variant: "solid",
  color: "accent",
  size: "default",
  type: "button"
});

const computedClass = computed(() =>
  cn(
    "ui-button",
    `ui-button--${props.variant}`,
    `ui-button--${props.color}`,
    `ui-button--${props.size}`,
    props.class
  )
);
</script>

<template>
  <button
    :type="type"
    :class="computedClass"
    :disabled="disabled || loading"
    :aria-busy="loading ? 'true' : undefined"
  >
    <span v-if="loading" class="ui-button__spinner" aria-hidden="true" />
    <slot />
  </button>
</template>
